import React, {useContext,useEffect,useState} from 'react';
import {  
  Modal  
} from 'carbon-components-react';

const MessageModal = ({messageCallback,messageModalCallback,closeMessageModalCallback}) => {

  const [messageModal, setMessageModal] = useState(true);
  
  const openMessageModal = () => {    
    setMessageModal(true);
  }

  const closeMessageModal = () => {    
    closeMessageModalCallback();
    setMessageModal(false);
  }  

  useEffect(() =>{
    setMessageModal(messageModalCallback);
  },[messageModalCallback])

  return (
    <>
      {messageCallback != '' &&

      
        <Modal
          className="Error-modal"          
          hasscrollingcontent="false"          
          aria-label="Error Modal"
          modalAriaLabel="Error Modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeMessageModal}
          onRequestSubmit={closeMessageModal}
          modalHeading={''}
          open={messageModal}
          size={'md'}
          isFullWidth={false}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Ok"          
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel="Invoice Approval System"
        >
          <p style={{fontSize:'18px'}}>{messageCallback}</p>
        </Modal>
      }
    </>
    
  );
};

export default MessageModal;